import * as React from "react";
import { PT_ProtectiveFunction } from "../models/PT_ProtectiveFunction";
import Modal from "react-bootstrap/Modal";
import { DM_PT_DataSheet } from "../models/DM_PT_DataSheet";
import { DeviceData } from "../models/DeviceData";
import { Message } from "../models/ProtectiveFunctionWrapper";
import { SilModal } from "./SilModal";

export interface ErrorAndWarningProps {
  messages: Message[];
  onClose: () => void;
}

export default class CalculationResultModal extends React.Component<ErrorAndWarningProps, {}> {
  render() {
    const errors = this.props.messages.filter(m => m.messageType == 'error');
    const warnings = this.props.messages.filter(m => m.messageType == 'warning');    
    const hasErrors = errors.length > 0;
    const hasWarnings = warnings.length > 0;
    const isReadOnly = this.props.messages.filter(m => m.messageType == 'readonly').length > 0; 
    const success = !hasErrors && !hasWarnings && !isReadOnly;

    let title = success ? "Calculation Complete" : `Calculation Completed With ${hasErrors ? 'Errors' : 'Warnings'}`;
    
    if (isReadOnly) {
      title = "Function Locked";
    }
    
    return (
      <SilModal closeModal={this.props.onClose} title={title} >
        <div>
          {success ? "Calculation completed successfully." : ""}
          {hasErrors ?
            <React.Fragment>
              Errors
              <ul>
              {
                errors.map((e, i) =>
                  <li key={i}>
                    {e.message}
                  </li>)
              }
              </ul> 
            </React.Fragment>
            : ''}
          {hasWarnings ?
            <React.Fragment>
              Warnings
                <ul>
                {warnings.map((e, i) =>
                  <li key={i}>
                    {e.message}
                  </li>)}
              </ul>
            </React.Fragment>
            : ''}
          {isReadOnly ?
              <React.Fragment>
                Operation not permitted.<br />
                This function is currently locked by another user.
              </React.Fragment>
              : ''}
          <div className="warning-footer ui-dialog-buttonpane ui-widget-content ui-helper-clearfix">
            <div className="left-div"></div>
            <div className="buttons">
              <button id="calc-ok" className="green-button" onClick={this.props.onClose}> Ok </button>
            </div>
          </div>
        </div>
      </SilModal>
    );
  }
}